<template>
    <div class="pay-order">
        <div class="pay-rule-item">
            <div class="pay-rule-item-line"></div>
            <p>皇家行前订</p>
        </div>
        <div class="order-notice" v-if="!pcpOrder || pcpOrder.orderStatus != 1 || pcpOrder.shopCartItems.length == 0">
            <div class="imme">
                <div class="unSelect">您尚未预订任何皇家行前订产品</div><div class="imaginary"></div>
                <div class="or-btn"><a @click="goToPcp" style="text-decoration: none;color: #282b2c">立即预订</a></div>
            </div>
            <div class="no">
                <div>注:</div>
                <div>皇家行前订产品价格不包含在船票费用中，将于登船后支付。</div>
            </div>
        </div>
        <div v-else>
            <div class="per">预定支付人: {{majorGuestName}}</div>
            <div class="list-item" v-for="(pcpOrder, i) in pcpOrderItems" :key="('pcpOrder_' + i)">
                <div class="pay-net">{{pcpOrder.category}}</div>
                <div class="pcp-all-imaginary"></div>
                <div class="img-desc" v-for="(item, j) in pcpOrder.items" :key="('pcpItem_' + i + '_'+ j)">
                    <img class="productItemImage" :class="{ 'shoppingMallImage': pcpOrder.category == '行前订商城'}"
                        :src="item.thumbnailIcon" :alt="item.thumbnailIconAlt"/>
                    <div class="detail">
                        <div class="d-title">{{item.name}}</div>

                        <div class="d-time" v-if="item.priceByRouteNights || item.priceByRouteDays">预定时段: 全程</div>

                        <div class="d-time" v-else-if="item.bundleType==1">
                            <span v-if="hasShipDate(item)">
                                预定时段: {{item.shipDate}}
                                <span v-if="hasTimeSlot(item)">
                                    {{item.timeSlotStartTime}} - {{item.timeSlotEndTime}}
                                </span>
                            </span>
                        </div>

                        <div v-else-if="item.bundleType==2">
                            <div class="checkOut-project-cell-txt2" >
                                预订时段：
                            </div>
                            <div class="packageItems">
                                <div v-for="(packageItem) in getPackageItems(item.productId, item.orderDetailId)" :key="('package_' + packageItem.orderDetailId)">
                                    <div class="relevanceProductName">{{packageItem.name}}</div>
                                    <div>
                                        <span class="relevanceProductShipdate"
                                        v-if="hasShipDate(packageItem)">
                                            {{packageItem.shipDate}}
                                            <span v-if="hasTimeSlot(packageItem)">
                                                {{packageItem.timeSlotStartTime}} - {{packageItem.timeSlotEndTime}}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-num">数&nbsp;量: <span>{{item.qty}}</span></div>
                        <div class="d-per" v-if="item.pcpCartItemBookingInfos && item.pcpCartItemBookingInfos.length > 0">
                            <div class="per-part">参&nbsp;&nbsp;与&nbsp;&nbsp;人: </div>
                            <div class="guestInfo">
                                <div class="d-order" v-for="(bookingInfo) in getPcpBookingInfos(item)"
                                :key="('bookingInfo_' + bookingInfo.bookingId)">
                                    <div class="d-item">
                                        <div class="code">&nbsp;船票订单号 {{bookingInfo.bookingId}}</div>
                                        <div class="roomCode">&nbsp;房间号 {{bookingInfo.stateroomNumber == 'GTY' ? '航司分配': bookingInfo.stateroomNumber}}</div>
                                        <div class="name">&nbsp;{{bookingInfo.guests.join(',')}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="price">
                            单&nbsp;&nbsp;价:
                          <span>{{item.priceDiscounted.toFixed("2")}} {{item.priceByRouteDays || item.priceByRouteNights ? '美元/航次/人' : item.priceUnit}}</span>
                        </div>
                        <div class="price" v-if="item.unitDiscountedServiceCharge > 0 && item.bundleType != 2 && item.hasServiceCharge">
                            <span class="tiny">含服务费：{{item.unitDiscountedServiceCharge.toFixed("2")}} 美元</span>
                        </div>
                    </div>
                    <div class="total">总计 <span>{{(item.priceDiscountedTotal).toFixed("2")}}</span> 美元</div>
                </div>

            </div>

            <div class="total-price">合计 <span>{{pcpOrder.priceDiscountedTotal.toFixed("2")}}</span> 美元</div>
            <div class="order-notice">
                <div class="imme">
                    <div class="unSelect">预订其他皇家行前订产品</div>
                    <div class="imaginary"></div>
                    <div class="or-btn"><a @click="goToPcp" style="text-decoration: none;color: #282b2c">立即预订</a></div>
                </div>
                <div class="no">
                    <div>注:</div>
                    <div>皇家行前订产品价格不包含在船票费用当中,将于登船后支付</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "BookingDetailPcp",
    props: {
        pcpOrder: {
            type: Object
        },
        booking: {
            type: Object
        }
    },
    data () {
        return {
            categories: ['WiFi套餐', '环球食刻', '畅享欢饮', '舞台巨制', '尊享服务', '海上潮玩', 'SPA', '光影典藏', '岸上观光']
        }
    },
    methods: {
        getPackageItems (productId, orderDetailId) {
            return this.packages.filter(r=>r.packageId == productId && r.packageOrderDetailId == orderDetailId)
        },
        hasShipDate (orderItem) {
            return orderItem.shipDate && orderItem.shipDate.length > 0 && orderItem.shipDate != '1753-01-01'
        },
        hasTimeSlot (orderItem) {
            return orderItem.timeSlotStartTime && orderItem.timeSlotStartTime.length> 0
            && orderItem.timeSlotEndTime && orderItem.timeSlotEndTime.length > 0
        },
        getPcpBookingInfos (orderItem) {
            let bookingInfos = []
            if (!orderItem.pcpCartItemBookingInfos || orderItem.pcpCartItemBookingInfos.length == 0) return []
            orderItem.pcpCartItemBookingInfos.forEach((item) => {
                let bookingInfo = bookingInfos.find(r=>r.bookingId == item.bookingId)
                if (bookingInfo) {
                    bookingInfo.guests.push(item.guestName)
                } else {
                    bookingInfos.push({
                        bookingId: item.bookingId,
                        stateroomNumber: item.stateroomNumber,
                        guests: [item.guestName]
                    })
                }
            })
            return bookingInfos
        },
        async goToPcp () {
            const { data } = await api.user.getPcpToken()
            let token = ""
            if (data && data.length > 0) {
                token = data
            }
            const url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/Home/Index?token=${token}`
            +`&sailDate=${this.booking.sailDate}&shipCode=${this.booking.shipCode}&encBookingId=${this.booking.encBookingId}`
            location.href = url
        }
    },
    computed: {
        packages () {
            return this.pcpOrder.packages || []
        },
        majorGuest () {
            if (!this.booking || !this.booking.bookingGuests) return {}
            return this.booking.bookingGuests.find(r=>r.id == this.pcpOrder.majorGuestId)
        },
        majorGuestName () {
            let guestName = ''
            if (this.majorGuest.chineseLastName && this.majorGuest.chineseLastName.length > 0
            && this.majorGuest.chineseFirstName && this.majorGuest.chineseFirstName.length > 0) {
                guestName = `${this.majorGuest.chineseLastName}${this.majorGuest.chineseFirstName} `
            }
            guestName += `${this.majorGuest.pinYinLastName} ${this.majorGuest.pinYinFirstName}`
            return guestName
        },
        pcpOrderItems () {
            if (!this.pcpOrder || !this.pcpOrder.shopCartItems || this.pcpOrder.shopCartItems.length == 0) {
                return []
            }
            let items = []
            let packageItemIds = []
            if (this.pcpOrder.packages) {
                packageItemIds = this.pcpOrder.packages.map(r=>r.orderDetailId)
            }
            this.categories.forEach((category) => {
                let categoryName = category + ''
                const orderItems = this.pcpOrder.shopCartItems
                .filter(r=>r.categoryName == categoryName && packageItemIds.indexOf(r.orderDetailId) < 0)
                if (orderItems.length > 0) {
                    items.push({
                        category,
                        items: orderItems
                    })
                }
            })
            return items
        },
        totalPrice () {
            let totalPrice = 0
            this.pcpOrderItems.forEach((orderItem) => {
                if (orderItem.items) {
                    orderItem.items.forEach((item) => {
                        totalPrice += item.priceDiscounted * item.qty
                    })
                }
            })

            return totalPrice
        },
        totalServiceCharges () {
            let totalPrice = 0
            this.pcpOrderItems.forEach((orderItem) => {
                if (orderItem.items) {
                    orderItem.items.forEach((item) => {
                        if (item.hasServiceCharge) {
                            totalPrice += item.priceServiceCharge * item.qty
                        }
                    })
                }
            })
            return totalPrice
        }
    }
}
</script>

<style lang="less" scoped>
.pay-order {
    background: #fff;
    padding-top: 15px;
    .order-notice {
        padding: 0 16px 0 20px;
        font-size: 12px;
        .imme {
            display: flex;
            padding-top: 10px;
            .unSelect {
                padding-top: 2px;
                flex: none;
                margin-right: 8px;
                color: #666;
            }
            .imaginary {
                border-top: 1px dotted #CCCCCC;
                flex: 1;
                margin-right: 8px;
                margin-top: 10px;
            }
            .or-btn {
                width: 81px;
                height: 25px;
                background: #FEBC10;
                text-align: center;
                line-height: 25px;
                font-size: 14px;
                color: #333;
                font-weight: 400;
                flex: none;
            }
        }
        .no {
            display: flex;
            padding-bottom: 8px;
            padding-top: 13px;
            color: #666;
        }
    }
    .per{
        padding-left: 28px;
        font-size: 12px;
        color: #333;
        margin-bottom: 18px;
        font-weight:bold;
    }
    .list-item {
        font-size: 12px;
        color: #4A90E2;
        padding: 0 16px 0 20px;
        .img-desc {
            display: flex;
            padding-top: 10px;
            color: #666;
            position: relative;
        }
        .img-desc>img{
            margin-right: 14px;
            margin-left: 10px;
        }
    }
    .pay-net {
        padding-left: 8px;
        padding-bottom: 8px;
        /* border-bottom: 1px solid #f6f7f8; */
        font-weight:bold;
    }
}


.detail{
    flex:1;
}

.detail .d-title{
    color: #333;
    font-size: 12px;
    font-weight:bold;
    padding-bottom:4px;
}

.guestInfo{
    flex:1;
    margin-left: 3px;
}

.d-order {
    flex: 1;
}

.d-item{
    position:relative;
    top:-1px;
}

.detail .d-order .code {
    font-size: 12px;
    color: #151515;
    letter-spacing: 0;
    line-height: 22px;
}
.detail .d-order .roomCode{
    margin-bottom: 2px;
}
.detail .d-per {
    display: flex;
}
.detail .price{
    margin-bottom: 30px;
}
.detail .price > span {
    color: #333;
}
.img-desc .total{
    color: #333;
    font-size: 12px;
    margin-bottom: 16px;
    position:absolute;
    bottom: -8px;
    right: 0;
}
.img-desc .total>span {
    color: #ff5055;
    font-weight: bold;
}
.list-item .img-desc{
    border-bottom: 1px solid #ccc;
}
.list-item .img-desc:last-child{
    border-bottom:0;
}
.list-item .img-desc>img {
    width: 101px;
    height: 62px;
}

.list-item .img-desc>img.shoppingMallImage {
    height: 101px;
}

.serviceCharge{
    padding-bottom:10px;
}
.total-price{
    text-align: right;
    font-size: 14px;
    padding: 18px 16px 18px 0;;
    border-top: 1px solid #f6f7f8;
}
.total-price > span {
    color: #ff5055;
    font-weight: bold;
}
.pay-order .list-item:last-child {
    border-bottom: 1px solid #f6f7f8;
}

.pcp-all-imaginary {
    border-bottom: 1px solid #ccc;
    width: 100%;
}

.checkOut-project-cell-txt2 {
    float: left;
}

.packageItems {
    position: relative;
    margin-left: 60px;
    font-weight: 400;
    color: #282b2c;
}
.relevanceProductName {
    font-weight: 400;
}

.relevanceProductShipdate {
    color: #8e8e93;
}

.pay-rule-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: #4A90E2;
    padding-left: 20px;
    position: relative;
    margin-bottom: 7px;
    .pay-rule-item-line {
        width: 3px;
        height: 12px;
        margin-right: 6px;
        background-color: #4A90E2;
    }
    p {
        font-weight: bold;
        margin: 0;
    }
}
</style>
